import * as ambassadorWixEventsNotificationsV2NotificationConfig from './events-notifications-v2-notification-config-notifications.http.js';
import * as ambassadorWixEventsNotificationsV2NotificationConfigTypes from './events-notifications-v2-notification-config-notifications.types.js';
import * as ambassadorWixEventsNotificationsV2NotificationConfigUniversalTypes from './events-notifications-v2-notification-config-notifications.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function resolveNotificationConfig(): __PublicMethodMetaInfo<
  'GET',
  { notificationConfigId: string },
  ambassadorWixEventsNotificationsV2NotificationConfigUniversalTypes.ResolveNotificationConfigRequest,
  ambassadorWixEventsNotificationsV2NotificationConfigTypes.ResolveNotificationConfigRequest,
  ambassadorWixEventsNotificationsV2NotificationConfigUniversalTypes.ResolveNotificationConfigResponse,
  ambassadorWixEventsNotificationsV2NotificationConfigTypes.ResolveNotificationConfigResponse
> {
  const payload = { notificationConfigId: ':notificationConfigId' } as any;

  const getRequestOptions =
    ambassadorWixEventsNotificationsV2NotificationConfig.resolveNotificationConfig(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/notification-configs/resolve/{notificationConfigId}',
    pathParams: { notificationConfigId: 'notificationConfigId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function upsertNotificationConfig(): __PublicMethodMetaInfo<
  'POST',
  { notificationConfigId: string },
  ambassadorWixEventsNotificationsV2NotificationConfigUniversalTypes.UpsertNotificationConfigRequest,
  ambassadorWixEventsNotificationsV2NotificationConfigTypes.UpsertNotificationConfigRequest,
  ambassadorWixEventsNotificationsV2NotificationConfigUniversalTypes.UpsertNotificationConfigResponse,
  ambassadorWixEventsNotificationsV2NotificationConfigTypes.UpsertNotificationConfigResponse
> {
  const payload = {
    notificationConfig: { id: ':notificationConfigId' },
  } as any;

  const getRequestOptions =
    ambassadorWixEventsNotificationsV2NotificationConfig.upsertNotificationConfig(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/notification-configs/{notificationConfig.id}',
    pathParams: { notificationConfigId: 'notificationConfigId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function triggerNotification(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsNotificationsV2NotificationConfigUniversalTypes.TriggerNotificationRequest,
  ambassadorWixEventsNotificationsV2NotificationConfigTypes.TriggerNotificationRequest,
  ambassadorWixEventsNotificationsV2NotificationConfigUniversalTypes.TriggerNotificationResponse,
  ambassadorWixEventsNotificationsV2NotificationConfigTypes.TriggerNotificationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsNotificationsV2NotificationConfig.triggerNotification(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/notifications/trigger',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  NotificationConfig as NotificationConfigOriginal,
  EmailNotificationConfig as EmailNotificationConfigOriginal,
  EmailNotificationType as EmailNotificationTypeOriginal,
  EmailNotificationTypeWithLiterals as EmailNotificationTypeWithLiteralsOriginal,
  EmailTemplate as EmailTemplateOriginal,
  Link as LinkOriginal,
  EmailNotificationReminderTime as EmailNotificationReminderTimeOriginal,
  EmailNotificationReminderTimeWithLiterals as EmailNotificationReminderTimeWithLiteralsOriginal,
  ResolveNotificationConfigRequest as ResolveNotificationConfigRequestOriginal,
  ResolveNotificationConfigResponse as ResolveNotificationConfigResponseOriginal,
  UpsertNotificationConfigRequest as UpsertNotificationConfigRequestOriginal,
  UpsertNotificationConfigResponse as UpsertNotificationConfigResponseOriginal,
  ResolveEmailNotificationConfigRequest as ResolveEmailNotificationConfigRequestOriginal,
  ResolveEmailNotificationConfigResponse as ResolveEmailNotificationConfigResponseOriginal,
  EventCanceled as EventCanceledOriginal,
  Empty as EmptyOriginal,
  EventDeleted as EventDeletedOriginal,
  EventCopied as EventCopiedOriginal,
  Location as LocationOriginal,
  MapCoordinates as MapCoordinatesOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  ScheduleConfig as ScheduleConfigOriginal,
  Recurrences as RecurrencesOriginal,
  Occurrence as OccurrenceOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  EventStatus as EventStatusOriginal,
  EventStatusWithLiterals as EventStatusWithLiteralsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  TriggerNotificationRequest as TriggerNotificationRequestOriginal,
  TriggerNotificationRequestNotificationOneOf as TriggerNotificationRequestNotificationOneOfOriginal,
  TriggerNotificationRequestGuestsOneOf as TriggerNotificationRequestGuestsOneOfOriginal,
  PushNotificationType as PushNotificationTypeOriginal,
  PushNotificationTypeWithLiterals as PushNotificationTypeWithLiteralsOriginal,
  RsvpGuest as RsvpGuestOriginal,
  OrderGuest as OrderGuestOriginal,
  EventGuests as EventGuestsOriginal,
  TicketGuest as TicketGuestOriginal,
  TriggerNotificationResponse as TriggerNotificationResponseOriginal,
  OrderConfirmed as OrderConfirmedOriginal,
  FormResponse as FormResponseOriginal,
  InputValue as InputValueOriginal,
  FormattedAddress as FormattedAddressOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  CommonStreetAddress as CommonStreetAddressOriginal,
  CommonAddressLocation as CommonAddressLocationOriginal,
  CommonSubdivision as CommonSubdivisionOriginal,
  StandardDetails as StandardDetailsOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  Ticket as TicketOriginal,
  CheckIn as CheckInOriginal,
  Money as MoneyOriginal,
  OnlineConferencingLogin as OnlineConferencingLoginOriginal,
  Invoice as InvoiceOriginal,
  Item as ItemOriginal,
  Discount as DiscountOriginal,
  DiscountItem as DiscountItemOriginal,
  DiscountItemDiscountOneOf as DiscountItemDiscountOneOfOriginal,
  CouponDiscount as CouponDiscountOriginal,
  PaidPlanDiscount as PaidPlanDiscountOriginal,
  PaidPlanDiscountDiscountOneOf as PaidPlanDiscountDiscountOneOfOriginal,
  PercentDiscount as PercentDiscountOriginal,
  Tax as TaxOriginal,
  TaxType as TaxTypeOriginal,
  TaxTypeWithLiterals as TaxTypeWithLiteralsOriginal,
  Fee as FeeOriginal,
  FeeName as FeeNameOriginal,
  FeeNameWithLiterals as FeeNameWithLiteralsOriginal,
  FeeType as FeeTypeOriginal,
  FeeTypeWithLiterals as FeeTypeWithLiteralsOriginal,
  OrderEmailAdded as OrderEmailAddedOriginal,
  OrderPaid as OrderPaidOriginal,
  TicketPdfResolved as TicketPdfResolvedOriginal,
  TicketPdfResolveDelayed as TicketPdfResolveDelayedOriginal,
  OrderCanceled as OrderCanceledOriginal,
} from './events-notifications-v2-notification-config-notifications.types.js';
